<template>
    <div>
        <div class="text-xl">Bankstatements by Illion</div>

        <div class="my-8">
            <div class="flex flex-wrap">
                <div class="w-full lg:w-1/2 pr-0 lg:pr-3 m-6">
                    <select class="form-control" v-on:change="institutionSelected($event)">
                        <option value="" selected disabled>Select institutions</option>
                        <option v-for="institution in institutionsList" :value="institution.slug" :key="institution.slug">{{ institution.slug }}</option>
                    </select>
                </div>
            </div>

            <div class="flex flex-wrap">
                <div class="w-full lg:w-1/2 pr-0 lg:pr-3 m-6">
                    <input v-model="username" placeholder="enter username">
                </div>
            </div>

            <div class="flex flex-wrap">
                <div class="w-full lg:w-1/2 pr-0 lg:pr-3 m-6">
                    <input v-model="password" placeholder="enter password">
                </div>
            </div>

            <button class="m-6 border-black-1000" v-on:click="login">Login</button>
        </div>
        <template v-if="accounts != null">
            <span><u><b>List of Bank Accounts</b></u></span>
            <div v-for="account in accounts" v-bind:key="account.id">
                <label>{{account.name}}</label>
                <input type="checkbox" v-model="selectedAccounts" v-bind:value="account.id"/>
            </div>
            <button class="m-6" v-on:click="generateStatements">Generate statements</button>
            <button class="m-6" v-on:click="downloadStatements">download statements</button>
        </template>
    </div>
</template>

<script>

    import Template from "./broker/template/Template";
    import axios from "axios";

    export default {
        components: {Template},
        data() {
            return {
                institutionsList: null, // list of institutions returned from api
                institutionSlug: null, // Slug value of institution that user has selected from dropdown
                username: null,
                password: null,
                userToken: null, // user token which will get returned with response from every endpoints and need to update to use latest token
                accounts: null, // user bank accounts that will be retrieved after user successfully login
                selectedAccounts: [], // bank accounts user will select to generate statement for
            }
        },

        created() {
            // get all institutions ->  https://docs.bankstatements.com.au/#list-institutions
                // get "slug" from bank/institutions
            this.getInstitutions();
            // Login -> https://docs.bankstatements.com.au/#login/
            // List accounts -> https://docs.bankstatements.com.au/#list-accounts
            // Retreive statements for specific accounts -> https://docs.bankstatements.com.au/#retrieve-statement-data
                // make request with : "accounts" : { "slug": [1,2 // ID of account ID from list accounts api ]}
        },

        methods: {
            institutionSelected(event) {
                this.institutionSlug = event.target.options[event.target.options.selectedIndex].text
            },

            getInstitutions() {
                this.apiGet({}, 'bankstatements/institutions', (response) => {
                    this.institutionsList = response.institutions;
                    this.userToken = response.userToken; // always assign updated user token that got returned
                })
            },

            loginPreload() {
                // if institution selected has flag "requires_preload=true" , then loginPreload is required and will get
                // user_token as response which will be used in subsequent login OR login and fetch all statements api calls.
            },

            login() {
                this.apiPost({
                    institutionSlug : this.institutionSlug,
                    username: this.username,
                    password: this.password,
                    brokerReferralCode : 'BKRP' // hardcoded for now
                }, 'bankstatements/authenticate-user', (response) => {
                    this.accounts = response.accounts;
                    this.userToken = response.user_token; // always assign updated user token that got returned
                })
            },

            generateStatements() {
                //  NOTE: pass in "generate_raw_file=true" to produce a file containing the raw bank data.
                //  You will then be able to perform a request to Retrieve Files to obtain the actual file
                this.apiPost({
                    userToken: this.userToken, // user token returned from the login
                    institutionSlug: this.institutionSlug,
                    accountIds: this.selectedAccounts
                }, 'bankstatements/statements', (response) => {
                    this.userToken = response.user_token; // always assign updated user token that got returned
                    this.downloadStatements();
                })
            },


            downloadStatements() {
                let params = {
                    'userToken': this.userToken
                };
                // GET: API call to get list of brokers
                axios.get(process.env.VUE_APP_API_URL + '/api/bankstatements/download-statements', {
                    params,
                    responseType: 'blob',
                    headers: {
                        'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
                    }
                }).then(response => {
                    // API request is successfully made
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'exportfile.zip'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                }).catch(e => {
                    console.log('error');
                })
            }
        }
    }

</script>
